import { successFeedback } from '../actions';
import { identityPayload, createReducer, forAction } from '../utils';

const initialState = false;

export default createReducer(
  [forAction(successFeedback, identityPayload)],
  initialState,
);
